export function PaymentOptions() {
    return (
        <ul>
            <li>PayPal: osuphil95@yahoo.com</li>
            <li>Venmo: @Philip-Schoch-2</li>
            <li>Check via mail:
                <address className="ps-4">
                    Phil Schoch<br></br>
                    1021 Woodman Drive<br></br>
                    Worthington, OH 43085
                </address>
            </li>
        </ul>
    )
}